import React from 'react';
import PropTypes from 'prop-types';
import { Pressable, Text, View } from 'react-native-web';
import styles from './styles';

// modified from mobile

const propTypes = {
  isMinimumMet: PropTypes.bool,
  isMinimumWomenMet: PropTypes.bool,
  isSuggestedMet: PropTypes.bool,
  setPopup: PropTypes.func,
};

const defaultProps = {
  isMinimumMet: false,
  isMinimumWomenMet: false,
  isSuggestedMet: false,
  setPopup: undefined,
};

const GameInfoBox = ({ isMinimumMet, isMinimumWomenMet, isSuggestedMet, setPopup }) => {
  const dropInText = 'Consider opening a drop-in spot if applicable.';
  const minWomenNotMetText = 'You have fewer than the minimum required women to play.';
  const minAmountNotMetText = 'You have fewer than the minimum required players to play.';
  const suggestedNotMet = 'You have fewer than the recommended number of players.';

  const allChecksPassed = isMinimumMet && isMinimumWomenMet && isSuggestedMet;
  const allChecksPassedText =
    'You`re all set for this game! Check back here for future games where you might need another player!';

  const getText = () => {
    if (!isMinimumWomenMet) return minWomenNotMetText;
    if (!isMinimumMet) return minAmountNotMetText;
    if (!isSuggestedMet) return suggestedNotMet;
    if (isSuggestedMet) return allChecksPassedText;

    return '';
  };

  return (
    <View
      style={[
        styles.container,
        !isSuggestedMet ? styles.suggestedNotMet : styles.checksPassed,
        !isMinimumWomenMet || !isMinimumMet ? styles.minimumNotMet : null,
      ]}
    >
      <View style={styles.row}>
        <Text style={styles.gameMessage}>
          {getText()} {!allChecksPassed ? dropInText : ''}
          <Pressable onPress={() => setPopup('whatsADropIn')}>
            <Text style={styles.infoLink}> What&apos;s a drop-in?</Text>
          </Pressable>
        </Text>
      </View>
    </View>
  );
};

GameInfoBox.propTypes = propTypes;
GameInfoBox.defaultProps = defaultProps;

export default GameInfoBox;
